export default "__VITE_ASSET__dogUWBHR__"